<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">This book is a work of fiction. References to real people, events, establishments, organizations, or locales are intended only to provide a sense of authenticity, and are used fictitiously. All other characters, and all incidents and dialogue, are drawn from the author’s imagination and are not to be construed as real.</p>
<p class="center spaceabove1">First Mariner Books edition 2021</p>
<p class="center spaceabove1"><span class="smallcaps">A LIE SOMEONE TOLD YOU ABOUT YOURSELF.</span> Copyright © 2021 by Peter Ho Davies.</p>
<p class="center spaceabove1">A Conversation with Peter Ho Davies copyright © 2021 by Peter Ho Davies<br/>
Reading Group Guide copyright © 2021 by HarperCollins Publishers LLC</p>
<p class="center spaceabove1">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles and reviews. For information, address HarperCollins Publishers, 195 Broadway, New York, NY 10007.</p>
<p class="center spaceabove1"><a href="https://marinerbooks.com/" target="_blank">marinerbooks.com</a></p>
<p class="center spaceabove1">Cover design © Kerry Rubenstein</p>
<p class="center ">Cover photograph © Getty Images/Chadeog I/EyeEm</p>
<p class="center ">Author photograph © Lynne Raughley</p>
<p class="center spaceabove1">Library of Congress Cataloging-in-Publication Data has been applied for.</p>
<p class="center "><span class="smallcaps">ISBN</span> 978-0-544-27771-7 hardcover<br/>
<span class="smallcaps">ISBN</span> 978-0-358-57287-9 paperback<br/>
<span class="smallcaps">ISBN</span> 978-0-544-27322-1 ebook<br/>
<span class="smallcaps">ISBN</span> 978-0-358-39504-1 audiobook</p>
<p class="center spaceabove1">v3.1221</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?7a825eb7